export default {
  placeholder: 'Wähle eine Datenquelle',
};
